var mutations = {
  /*setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },*/
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/mutations.js